import React, { ChangeEvent, useEffect, useState } from "react";
import { regularFont } from "../../utils/styles";
import AttendanceStyles from "./Attendance.styles";
import CustomBreadcrumb from "../../global/components/CustomBreadcrumb/CustomBreadcrumb";
import CustomPageHeader from "../../global/components/CustomPageHeader/CustomPageHeader";
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputAdornment,
  MenuItem,
  Pagination,
  Popover,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import AttendanceStatusBox from "./components/AttendanceStatusBox";
import TotalDaysIcon from "../../assets/icons/TotalIcon.svg";
import CustomButton from "../../global/components/CustomButton/CustomButton";
import CustomInput from "../../global/components/CustomInput/CustomInput";
import { MataDataTeamData } from "../../Models/Interface";
import SearchIcon from "@mui/icons-material/Search";
import {
  debounceEventHandler,
  isTruthy,
  openErrorNotification,
  openSuccessNotification,
} from "../../helpers/methods";
import strings from "../../global/constants/StringConstants";
import CustomTable from "../../global/components/CustomTable/CustomTable";
import {
  AttendanceAllData,
  AttendanceHeader,
  AttendanceHeaderALL,
  TeamTableData,
} from "./AttendanceData";
import {
  attendanceApprove,
  getAllUserWiseAttendance,
  getUserWiseAttendance,
} from "./AttendanceService";
import customErrorHandler from "../../utils/customErrorHandler";
import notifiers from "../../global/constants/NotificationConstants";
import { useAppSelector } from "../../utils/hooks";
import { selectUserId } from "../../redux/authSlice";
import moment from "moment";
import filterIcon from "../../assets/icons/filterIcon.svg";
import filter_dropDown from "../../assets/icons/filter_dropDown.svg";
import { ReactComponent as VerticalDotIcon } from "../../assets/icons/verticalDot.svg";
import ViewTeamAttendance from "./components/ViewTeamAttendance/ViewTeamAttendance";
import { store } from "../../utils/store";
import {
  DataGridPro,
  GridColDef,
  GridRenderCellParams,
  GridToolbar,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
  GridValueGetterParams,
  LicenseInfo,
} from "@mui/x-data-grid-pro";
import customTableStyles from "../../global/components/CustomTable/customTable.styles";
import { applyLicenseKey } from "../../utils/License";
import paginationStyles from "../../global/components/CustomTable/Pagination.styles";

const breadCrumbList = [
  {
    name: "Attendance",
  },
];
const Attendance = () => {
  const classes = AttendanceStyles;
  const privileges = store.getState().auth?.privileges || {};
  const userIdFromRedux = useAppSelector(selectUserId);
  const [attendanceDatam, setAttendanceDatam] = useState({
    TotalDays: 0,
  });
  const [userDataSource, setUserDataSource] = useState<any>([]);
  const [userDataSource1, setUserDataSource1] = useState<any>([]);
  const [paginationModel, setPaginationModel] = React.useState({
    pageSize: 25,
    page: 0,
  });
  const [search, setSearch] = useState<string>("");
  const handlePageSizeChange = (event: any) => {
    setPaginationModel({
      ...paginationModel,
      pageSize: event.target.value,
      page: 0,
    });
  };
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [count, setCount] = useState<number>(5);
  const [attendanceInfo, setAttendanceInfo] = useState<any>([]);
  const [fixData, setFixData] = useState<any[]>([]);
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [pageNumber, setPageNumber] = React.useState(0);
  const userPerPage = 10;
  const userCount = userDataSource.length;
  const pageVisited = pageNumber * userPerPage;
  const displayRows = userDataSource?.slice(
    pageVisited,
    pageVisited + userPerPage
  );
  const customTableClasses = customTableStyles;

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [viewAttendance, setViewAttendance] = useState(false);
  const [viewInfoUserId, setViewInfoUserId] = useState<string>("");
  const [user_id, setUser_id] = useState("");
   const [metaData, setMetaData] = useState<any>({});
  // const userRole = store.getState().auth.role;


  useEffect(() => {
    applyLicenseKey();
  }, []);


  useEffect(() => {
    getUserAttendance();
  }, []);
 
    useEffect(() => {
      getUserAttendance();
    }, [search]);


  const handleSearch = async (newValue: string) => {
    setSearch(newValue);
    await getUserAttendance();
  };
    
  // const handleChangePage = (
  //   event: React.MouseEvent<HTMLButtonElement> | null,
  //   newPage: number
  // ) => {
  //   setPageNumber(newPage);
  // };





  const handleRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handlePopOver = (
    event: React.MouseEvent<HTMLButtonElement>,
    userId: any,
    user_id: any
  ) => {
    setAnchorEl(event.currentTarget);
    setViewInfoUserId(userId);
    setUser_id(user_id);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  // const getCurrentDateMatches = (data: any) => {
  //   const currentDate = moment().format("DD/MM/YYYY");
  //   const matchingItems = data.filter((item: any) => {
  //     const itemDate = moment(item.date, "DD/MM/YYYY").format("DD/MM/YYYY");
  //     return itemDate === currentDate;
  //   });
  //   return matchingItems;
  // };

  const HandleApprove = async (viewInfoUserId: any, buttonLabel: any) => {
    try {
      const reqApprove: any = buttonLabel === "Approve" ? 1 : 2;
      const response: any = await attendanceApprove(
        userIdFromRedux,
        user_id,
        reqApprove
      );
      customErrorHandler(response);
      openSuccessNotification(response.message);
    } catch (error: any) {
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };
  const columns: GridColDef[] = [
    {
      headerName: "Team Name",
      field: "team_name",
      filterable: true,
      minWidth: 160,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => (
        <Stack
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Typography
            sx={classes.teamName}
            onClick={(event: any) => {
              handleViewAttendance(params.row?.userId);
            }}
          >
            {params.row?.team_name}
          </Typography>
        </Stack>
      ),
    },
    // {
    //   headerName: "Type",
    //   field: "work_type",
    //   minWidth: 111,
    //   flex: 1,
    //   renderCell: (params: GridRenderCellParams) => (
    //     <Stack
    //       direction="column"
    //       justifyContent="flex-start"
    //       alignItems="flex-start"
    //       spacing={1}
    //     >
    //       <Typography sx={classes.rowtext}>{params.row?.work_type}</Typography>
    //     </Stack>
    //   ),
    // },
    {
      headerName: "In-Time",
      field: "in_time",

      minWidth: 182,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => (
        <Stack
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Typography sx={classes.rowtext}>{params.row.punch_in}</Typography>
        </Stack>
      ),
    },

    {
      headerName: "Out Time",
      field: "punch_out",
      minWidth: 221,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => (
        <Stack
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Typography sx={classes.rowtext}>{params.row.punch_out}</Typography>
        </Stack>
      ),
    },

    {
      headerName: "Working Hours",
      field: "working_hours",
      minWidth: 150,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => (
        <Stack
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Typography sx={classes.rowtext}>
            {params.row?.working_hours}
          </Typography>
        </Stack>
      ),
    },
    {
      headerName: "Overtime Hours",
      field: "LeaveBalance",
      minWidth: 128,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => (
        <Stack
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Typography sx={classes.rowtext}>
            {params.row.overtime_hours < 0 ? "00.0" : params.row.overtime_hours}
          </Typography>
        </Stack>
      ),
    },
    {
      headerName: "Status",
      field: "	Attendace",
      minWidth: 111,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => (
        <Stack
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Typography sx={classes.rowtext}>
            {Number(params.row?.status) == 0 ? "Absent" : "Present"}
          </Typography>
        </Stack>
      ),
    },
  ];
  // const getUserAttendance = async () => {
  //   try {
  //     const response = await getAllUserWiseAttendance();
  //     customErrorHandler(response);
  //     const responseData = response.data;

  //     const filteredData = responseData.filter((item: any) =>
  //       item.users[0].name.toLowerCase().includes(search.toLowerCase())
  //     );

  //     const mappedItems = responseData.map((item: any) => {
  //       let typeColor;
  //       if (item.work_type === "Present") {
  //         typeColor = "#18CB8A";
  //       } else if (item.work_type === "Half Day") {
  //         typeColor = "#F4BE5E";
  //       } else if (item.work_type === "Absent" || item.type === "Leave") {
  //         typeColor = "#E92B2B";
  //       }
  //       const userNames = item.users.map((user: any) => user.name).join(", "); // Retrieve all user names as a string
  //       let overtimeHours: any = parseFloat(item.working_hours) - 8; // Calculate the overtime hours
  //       overtimeHours = overtimeHours < 0 ? "00.0" : overtimeHours.toFixed(2); // Display "00.0" if overtimeHours is NaN
  //       return {
  //         team_name: (
  //           <Typography
  //             sx={classes.teamName}
  //             onClick={(event: any) => {
  //               handleViewAttendance(item.userId);
  //             }}
  //           >
  //             {userNames}
  //           </Typography>
  //         ),
  //         work_type: item.work_type,
  //         in_time: item.punch_in,
  //         out_time: item.punch_out,
  //         working_hours: item.working_hours,
  //         overtime_hours: overtimeHours,
  //         type: (
  //           <Typography
  //             sx={{ ...regularFont, fontSize: "14px" }}
  //             style={{ color: typeColor }}
  //           >
  //             {item.work_type}
  //           </Typography>
  //         ),
  //         // location: (
  //         //   <>
  //         //     <Box sx={classes.activeBtn}>
  //         //       <CustomButton
  //         //         label={"View"}
  //         //         buttonType="primaryBtn"
  //         //         onClick={() => { }}
  //         //       />
  //         //     </Box>
  //         //   </>
  //         // ),
  //         // action: (
  //         //   <>
  //         //     <Box sx={classes.verticalDotButton}>
  //         //       <Button
  //         //         onClick={(event) =>
  //         //           handlePopOver(event, item.userId, item._id)
  //         //         }
  //         //       >
  //         //         <VerticalDotIcon />
  //         //       </Button>
  //         //     </Box>
  //         //   </>
  //         // ),
  //       };
  //     });
  //     const source1 = response.data.map((userData: any) => {
  //       return {
  //         ...userData,
  //         team_name: userData?.users[0]?.name,
  //         overtime_hours: parseFloat(userData.working_hours) - 8,
  //       };
  //     });
  //     setUserDataSource1([...source1]);
  //     // setUserDataSource1([...filteredData]);

  //     setUserDataSource(mappedItems);
  //     setFixData(mappedItems);
  //   } catch (error: any) {
  //     if (customErrorHandler({}, error) === false) return;
  //     openErrorNotification(
  //       isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
  //     );
  //   }
  // };

  // get value from Input field
  
  
  const getUserAttendance = async () => {
    try {
      const response = await getAllUserWiseAttendance();
      customErrorHandler(response);
      const responseData = response.data;
  
      // If search is empty, display all data
      const filteredData =
        search.trim() === ""
          ? responseData
          : responseData.filter((item: any) =>
              item.users[0].name.toLowerCase().includes(search.toLowerCase())
            );
  
      const mappedItems = filteredData.map((item: any) => {
        let typeColor;
        if (item.work_type === "Present") {
          typeColor = "#18CB8A";
        } else if (item.work_type === "Half Day") {
          typeColor = "#F4BE5E";
        } else if (item.work_type === "Absent" || item.type === "Leave") {
          typeColor = "#E92B2B";
        }
        const userNames = item.users.map((user: any) => user.name).join(", ");
        let overtimeHours: any = parseFloat(item.working_hours) - 8;
        overtimeHours = overtimeHours < 0 ? "00.0" : overtimeHours.toFixed(2);
  
        return {
          team_name: (
            <Typography
              sx={classes.teamName}
              onClick={(event: any) => {
                handleViewAttendance(item.userId);
              }}
            >
              {userNames}
            </Typography>
          ),
          work_type: item.work_type,
          in_time: item.punch_in,
          out_time: item.punch_out,
          working_hours: item.working_hours,
          overtime_hours: overtimeHours,
          type: (
            <Typography
              sx={{ ...regularFont, fontSize: "14px" }}
              style={{ color: typeColor }}
            >
              {item.work_type}
            </Typography>
          ),
        };
      });
  
      const source1 =
        search.trim() === ""
          ? responseData.map((userData: any) => ({
              ...userData,
              team_name: userData?.users[0]?.name,
              overtime_hours: parseFloat(userData.working_hours) - 8,
            }))
          : responseData
              .filter((userData: any) =>
                userData?.users[0]?.name.toLowerCase().includes(search.toLowerCase())
              )
              .map((userData: any) => ({
                ...userData,
                team_name: userData?.users[0]?.name,
                overtime_hours: parseFloat(userData.working_hours) - 8,
              }));
  
      setUserDataSource1([...source1]);
      setUserDataSource(mappedItems);
      setFixData(mappedItems);
    } catch (error: any) {
      if (customErrorHandler({}, error) === false) return;
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };
  
  
  
  
  const handleSearchOnChange = async (
    SearchEvent: ChangeEvent<HTMLInputElement>
  ) => {
    if (SearchEvent.target.value) {
      setSearch(SearchEvent.target.value.replace(/\s/g, ""));
    } else {
      setSearch("");
    }
  };

  // const tableDataShowHandler = () => {
  //   const tableData = TeamTableData.map((item: any, index: any) => {
  //     return {
  //       Date: <Typography>{item.Department}</Typography>,
  //       punch_in: item.Designation,
  //       punch_out: <Typography>{item.Action}</Typography>,
  //     };
  //   });
  //   setUserDataSource(tableData);
  // };

  const handleViewAttendance = (Id: any) => {
    setViewInfoUserId(Id);
    setViewAttendance(true);
  };
  function CustomToolbar() {
    return (
      <GridToolbarContainer
        sx={{ width: "100%", justifyContent: "space-between" }}
      >
        <Box>
          {/* <GridToolbarQuickFilter />
          <GridToolbarFilterButton /> */}
          <TextField
            id="outlined-search"
type="search"
            placeholder="Search"
            variant="standard"
            value={search}
            onChange={(e) => handleSearch(e.target.value)}
            sx={{
              width: "100%",
              fontSize: "12px",
            }}
            autoFocus={isSearchFocused}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            onFocus={() => setIsSearchFocused(true)}
            onBlur={() => setIsSearchFocused(false)}
          />
        </Box>
        <Box sx={{ justifyContent: "end" }}>
          <GridToolbarColumnsButton />
        </Box>
      </GridToolbarContainer>
    );
  }
  const handleViewAttendanceClose = () => {
    setViewAttendance(false);
  };

  const [value, setValue] = useState<any>({
    startDate: new Date(),
    endDate: new Date().setMonth(11),
  });

  const handleValueChange = (newValue: any) => {
    setValue(newValue);
  };

  const getAttendancePage = () => {
    return (
      <>
        <Box sx={classes.attendanceWrapper}>
          <CustomPageHeader
            heading="Attendance"
            subInfo="Manage your attendance list here"
          />
          {privileges &&
          (privileges?.["All Attendance"].includes("view") ||
            privileges?.["All Attendance"].includes("full control")) ? (
            <>
              <Grid container mt={1} sx={customTableClasses.tableGridPart}>
                <Grid item xs={12} sx={customTableClasses.dataGridContainer}>
                  {/* <CustomTable
                    headers={AttendanceHeaderALL}
                    rows={displayRows}
                    size={[5]}
                    handlePageChange={handleChangePage}
                    handleRowsPerPage={handleRowsPerPage}
                    paginationCount={userCount}
                    rowsPerPage={rowsPerPage}
                    pageNumber={pageNumber}
                  /> */}
                  <DataGridPro
                    columns={columns}
                    rows={userDataSource1}
                    getRowId={(row) => row._id}
                    rowHeight={95}
                    sx={customTableClasses.gridRow}
                    getRowClassName={(params) =>
                      `${customTableClasses.tableRow}`
                    }
                    density="compact"
                    rowsLoadingMode="server"
                    slots={{
                      toolbar: CustomToolbar,
                    }}
                    localeText={{
                      noRowsLabel: "No data found",
                    }}
                  />

                  <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    sx={{ top: "10px", left: "-20px" }}
                    onClose={handleClose}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "left",
                    }}
                  >
                    <Box sx={classes.innerPopOver}>
                      <CustomButton
                        label="View"
                        onClick={() => {
                          handleViewAttendance(viewInfoUserId);
                        }}
                      />
                      {
                        <>
                          <CustomButton
                            label="Approve"
                            onClick={() => {
                              HandleApprove(viewInfoUserId, "Approve");
                            }}
                          />
                          <CustomButton
                            label="DisApprove"
                            onClick={() => {
                              HandleApprove(viewInfoUserId, "DisApprove");
                            }}
                          />
                        </>
                      }
                    </Box>
                  </Popover>
                </Grid>
              </Grid>
              {viewAttendance && (
                <ViewTeamAttendance
                  handleViewAttendanceClose={handleViewAttendanceClose}
                  viewInfoUserId={viewInfoUserId}
                />
              )}

              <Box sx={paginationStyles.footer}>
                <Box sx={paginationStyles.footerRight}>
                  <div style={{ marginRight: "8px" }}>Rows per page</div>

                  <FormControl size="small" sx={{ border: "none" }}>
                    <Select
                      value={paginationModel.pageSize}
                      onChange={handlePageSizeChange}
                      label="Page Size"
                      sx={{
                        fontSize: "11px",
                        border: "none",
                        minWidth: "60px",
                      }}
                    >
                      <MenuItem value={10} sx={paginationStyles.menuItem}>
                        10
                      </MenuItem>
                      <MenuItem value={25} sx={paginationStyles.menuItem}>
                        25
                      </MenuItem>
                      <MenuItem value={50} sx={paginationStyles.menuItem}>
                        50
                      </MenuItem>
                      <MenuItem value={100} sx={paginationStyles.menuItem}>
                        100
                      </MenuItem>
                      <MenuItem value={200} sx={paginationStyles.menuItem}>
                        200
                      </MenuItem>
                    </Select>
                  </FormControl>

                  <Pagination
                    count={Math.ceil(
                      metaData?.total / paginationModel.pageSize
                    )}
                    page={paginationModel.page + 1}
                    onChange={(event, value) => {
                      setPaginationModel({
                        ...paginationModel,
                        page: value - 1,
                      });
                    }}
                    size="small"
                    siblingCount={1}
                    boundaryCount={1}
                    sx={paginationStyles.font}
                  />
                </Box>
              </Box>
            </>
          ) : (
            ""
          )}
        </Box>
      </>
    );
  };

  return getAttendancePage();
};

export default Attendance;
